import { FC, ReactNode, useEffect, useState } from 'react';
import styles from './styles.module.css';
import ToastPopUpContainer from '../ToastPopUp';
import {
  useCancelCalcAllocationMutation,
  useConfirmCalcAllocationFailedMutation,
  useDeleteCalcAllocationFailedMutation,
  useGetCalcAllocationStatusWithoutLoadingQuery,
} from '../../../api/carAllocationApi';
import AllocationStatusIndicator from '../AllocationStatusIndicator';
import { QueryStatus } from '@reduxjs/toolkit/query';
import { logger } from '../../../services/logger';

type Props = {
  children?: ReactNode;
  setIsNeedBottomMargin: (showToastPopUp: boolean) => void;
};
const FooterControl: FC<Props> = ({ children, setIsNeedBottomMargin }) => {
  const { data, refetch } = useGetCalcAllocationStatusWithoutLoadingQuery();
  useEffect(() => {
    if (data && data.status !== 'ready') {
      setIsVisible(true);
    }
  }, [data]);
  const [cancel, { status: cancelStatus }] = useCancelCalcAllocationMutation();
  const [cancelFailed] = useDeleteCalcAllocationFailedMutation();
  const [confirmFailed] = useConfirmCalcAllocationFailedMutation();
  useEffect(() => {
    if (cancelStatus === QueryStatus.fulfilled) {
      refetch();
    }
  }, [cancelStatus]);
  const [isVisible, setIsVisible] = useState(false);
  setIsNeedBottomMargin(isVisible);

  return (
    <div className={styles.footerControlContainer}>
      <ToastPopUpContainer />
      {data && isVisible && (
        <AllocationStatusIndicator
          status={data.status}
          isSelfExecuted={data.isSelfExecuted}
          onCancel={() => {
            cancel(data.optimizationJobId)
              .unwrap()
              .then(() => setIsVisible(false))
              .catch(logger.error);
          }}
          onClose={() => {
            setIsVisible(false);
          }}
          onAbortedCancel={() => {
            cancelFailed(data.optimizationJobId)
              .unwrap()
              .then(() => setIsVisible(false))
              .catch(logger.error);
          }}
          onAbortedUpdate={() => {
            confirmFailed(data.optimizationJobId)
              .unwrap()
              .then(() => setIsVisible(false))
              .catch(logger.error);
          }}
        ></AllocationStatusIndicator>
      )}
      {children && <div className={styles.footerControls}>{children}</div>}
    </div>
  );
};

export default FooterControl;
